import { defineMessages } from 'react-intl';

const ID_PREFIX = 'WacSignupForm.';

export const messages = defineMessages({
  heading: {
    id: `${ID_PREFIX}signupOfferingIncludesFeaturesSignupFormHeading`,
    defaultMessage: 'Start now'
  },
  subheading: {
    id: `${ID_PREFIX}signupOfferingIncludesFeaturesSignupFormSubheading`,
    defaultMessage: ''
  },
  greeting: {
    id: `${ID_PREFIX}signupFormPersonalizedGreeting`,
    defaultMessage: 'Welcome back, {username}'
  }
});
